module.exports = __webpack_public_path__ + "img/Stat_lvl.739c3535.png";